import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

let loadingRequestCount = 0
let loadingInstance

const showLoading = () => {
  if (loadingRequestCount === 0) {
    loadingInstance = Loading.service({ target: '.loadingtext'})
  }
  loadingRequestCount++
}

const hideLoading = () => {
  if (loadingRequestCount <= 0) return
  loadingRequestCount--
  if (loadingRequestCount === 0) {
    loadingInstance.close()
  }
}


// axios.defaults.withCredentials = true
axios.defaults.withCredentials = false
axios.defaults.headers.common['Content-Type'] = 'application/json, text/plain'
axios.defaults.headers.post['Content-Type'] = ' application/x-www-form-urlencoded'
// axios.defaults.headers.common['Authorization'] = getToken('token')
// axios.defaults.headers.common['Client'] = 'pc_admin'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
axios.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    showLoading()
    // do something before request is sent

    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    // //debugger
    if (config.url !== '/login' || config.url.split('?')[0] !== '/ssologin') {
      config.headers['Authorization'] = getToken()
      // config.headers['Authorization'] = 'Basic YW1hemluZ2xhbmQ6YW1hemluZ2xhbmQ='
    } else {
      // config.headers['Authorization'] = process.env.VUE_APP_BASIC_TOKEN
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    setTimeout(() => {
      hideLoading()
    }, 200)

    const res = response.data
    // //debugger
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 999 || res.code === 50012 || res.code === 50014) {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
        // to re-login
        // MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        //   confirmButtonText: 'Re-Login',
        //   cancelButtonText: 'Cancel',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('user/resetToken').then(() => {
        //     location.reload()
        //   })
        // })
      }else{
        Message({
          offset: 70,
          message: res.message ||res.msg|| 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      // return Promise.reject(new Error(res.msg || 'Error'))
      return res
    } else {
      return res
    }
  },
  error => {
    setTimeout(() => {
      hideLoading()
    }, 200);
    console.log('err' + error) // for debug
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
